import css from 'styled-jsx/css';

const styles = css.global`#santander-parceiros {
  background: #444;
  padding: 32px 0;
  overflow: hidden;
}

#santander-parceiros .santander-parceiros-title {
  color: #FFF;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}

#santander-parceiros .santander-parceiros-text {
  color: #FFF;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: 16px;
}

#santander-parceiros .santander-parceiros-carrossel {
  width: 100%;
  margin-top: 17px;
}

#santander-parceiros .santander-parceiros-carrossel .parceiros-card {
  width: 163px;
  height: 127px;
  display: inline-block;
  margin-right: 26px;
}

/* #santander-parceiros .santander-parceiros-carrossel .parceiros-card img {
  border-radius: 4px;
} */

#santander-parceiros div.slide {
  flex: 0 0 163px;
}

#santander-parceiros .home-pagination {
  margin-top: 24px;
}

#santander-parceiros .home-pagination .embla__prev {
  width: 24px;
  height: 24px;
  background-image: url(assets/home24/shared/ic_arrow_left_white.svg);
  background-size: 24px 24px;
}

#santander-parceiros .home-pagination .embla__next {
  width: 24px;
  height: 24px;
  background-image: url(assets/home24/shared/ic_arrow_right_white.svg);
  background-size: 24px 24px;
}

@media (min-width: 994px) {
  #santander-parceiros {
    padding: 40px 0;
  }

  #santander-parceiros .santander-parceiros-carrossel {
    overflow: hidden;
  }
  #santander-parceiros .santander-parceiros-carrossel .parceiros-card {
    margin-right: 22px;
  }
}

@media (min-width: 1250px) {
  /* #santander-parceiros .home-pagination {
    display: none;
  } */
  #santander-parceiros .santander-parceiros-carrossel .parceiros-card {
    margin-right: 27px;
  }
}`;

export default styles;